import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import './BackArrow.css';

const BackArrow = () => {
    const navigate = useNavigate();
  
    return (
      <FontAwesomeIcon
        icon={faArrowLeftLong}
        onClick={() => navigate(-1)}
        className="back-arrow"
      />
    );
  };

  export default BackArrow;